var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomainTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 45,
    viewBox: "0 0 44 45",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 9.20093,
    x2: 39.2942,
    y1: 33.9429,
    y2: 0.533591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4312a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25638,
    stopColor: "#6233df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849bff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.9474 11c-1.2795 0-2.3158 1.0363-2.3158 2.3158v8.1053c0 1.2794 1.0363 2.3157 2.3158 2.3157h3.4737v3.4737c0 1.2657 1.0501 2.3158 2.3157 2.3158h8.1053c1.2657 0 2.3158-1.0501 2.3158-2.3158v-8.1052c0-1.2657-1.0501-2.3158-2.3158-2.3158h-3.4737v-3.4737c0-1.2795-1.0363-2.3158-2.3158-2.3158zm10.421 8.1053h3.4737v8.1052h-8.1053v-3.4737h2.3158c1.2795 0 2.3158-1.0363 2.3158-2.3157zm-17.3684 4.6315v4.6316c0 1.2657 1.0501 2.3158 2.3158 2.3158h3.4737v2.3158l3.4737-3.4737-3.4737-3.4737v2.3158h-3.4737v-4.6316z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainTransfer);
export default __webpack_public_path__ + "static/media/domain-transfer.7859cfce94ee441f91ffb36f41314881.svg";
export { ForwardRef as ReactComponent };